import { Action } from '@ngrx/store';
import { AppUser } from '../../models/user.model';

export const USER_LOGIN = '[User] Login';
export const USER_LOGOUT = '[User] Logout';
export const USER_LOGIN_SUCCESS = '[User] Login Success';
export const USER_LOGIN_FAIL = '[User] Login Fail';
export const USER_UPDATE_DATA = '[User] Update Data';
export const USER_UPDATE_DATA_SUCCESS = '[User] Update Data Success';
export const USER_UPDATE_DATA_FAIL = '[User] Update Data Fail';


export class Login implements Action {
  readonly type = USER_LOGIN;
  constructor(public payload: {login: string, password: string}) { }
}

export class Logout implements Action {
  readonly type = USER_LOGOUT;
  constructor() { }
}

export class LoginSuccess implements Action {
  readonly type = USER_LOGIN_SUCCESS;
  constructor(public payload: AppUser) { }
}

export class LoginFail implements Action {
  readonly type = USER_LOGIN_FAIL;
  constructor(public payload: string) { }
}

export class UpdateData implements Action {
  readonly type = USER_UPDATE_DATA;
  constructor(public payload: AppUser) { }
}

export class UpdateDataSuccess implements Action {
  readonly type = USER_UPDATE_DATA_SUCCESS;
  constructor(public payload: string) { }
}

export class UpdateDataFail implements Action {
  readonly type = USER_UPDATE_DATA_FAIL;
  constructor(public payload: string) { }
}

export type UserAction = Login | LoginSuccess | LoginFail | UpdateData |
  UpdateDataSuccess | UpdateDataFail | Logout;
